import { Stack, Typography } from "@mui/material";

export default function DailyGapConsumedHeader() {
  return (
    <Stack
      spacing="4px"
      sx={{
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
        }}
      >
        % GAP
      </Typography>
      <Typography
        sx={{
          color: "#222F5A",
          fontWeight: 500,
        }}
      >
        Consumido diario
      </Typography>
    </Stack>
  );
}
